// Generated by CoffeeScript 2.7.0
var CONFIRM_CONTENT, SettingsNamespaceStatus;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

CONFIRM_CONTENT = "<p>如遇无法删除成员，可能是以下问题所致：</p> <ul> <li>他可能是某个组织的创建者或管理员</li> <li>他可能发布过消息或是消息的协作者</li> <li>他可能是超级管理员</li> </ul> <p>您可以尝试通过“转交用户”功能将该的用户所有权转移给他人</p>";

export default SettingsNamespaceStatus = Vue.extend({
  components: {
    'settings-container': SettingsContainer,
    'Popover': Popover
  },
  props: {
    activeTab: {
      type: String
    },
    namespaceStatus: {
      type: Object
    }
  },
  data: function() {
    return {
      processPercent: 0
    };
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="content-head">
      <label class="head-label" @click="deleteSuspendedMembers">
        <button class="text-btn btn-primary">
          <i class="slp-trash"></i>
          <span>删除成员</span>
        </button>
        <div class="helper-text">（批量删除不在任何组织成员）</div>
      </label>
      <label class="head-label">
        <Popover position='bottom center' :customClass='"export-confirm-popover confirm"' ref="exportConfirmPopoverRef">
          <template slot='trigger'>
            <div class="btn text-btn btn-primary" >
              <i class="slp-upload-o"></i>
              <span>导出成员</span>
            </div>
          </template>
          <template slot='content'>
            <div class="popover-confirm-content">
              <div class="popover-confirm-title">导出全部成员</div>
              <div class="popover-confirm-body">确定导出所有成员的绑定关系？</div>
              <div class="popover-confirm-footer">
                <span class="btn btn-small btn-default outlined" @click="exportConfirmPopoverCancel">取消</span>
                <span class="btn btn-small btn-primary" @click="exportUsers">确定</span>
              </div>
            </div>
          </template>
        </Popover>
        <div class="helper-text">（导出所有成员的绑定关系）</div>
      </label>
    </div>
    <div class="content-body">
      <div class="item">
        <div class="item-title">成员</div>
        <div class="process-bar thin">
          <div class="content" style="processBarWidth"></div>
        </div>
        <div class="helper-text">{{ membersDescription }}</div>
      </div>
      <div class="item">
        <div class="item-title">组织</div>
        <div class="organization-description">{{ organizationsDescription }}</div>
      </div>
    </div>
  </template>
</settings-container>`,
  computed: {
    membersDescription: function() {
      var allMembers, bindMembers;
      allMembers = this.namespaceStatus.all_members_count;
      bindMembers = this.namespaceStatus.binded_members_count;
      this.processPercent = ((bindMembers / allMembers) * 100).toFixed(2);
      return `${allMembers}个成员中绑定了${bindMembers}人，约绑定${this.processPercent}%`;
    },
    processBarWidth: function() {
      return {
        width: this.processPercent
      };
    },
    organizationsDescription: function() {
      var organizationsCount, rootOrganizationsCount;
      organizationsCount = this.namespaceStatus.organizations_count;
      rootOrganizationsCount = this.namespaceStatus.root_organizations_count;
      return `共${organizationsCount}个组织，其中含${rootOrganizationsCount}顶级组织`;
    }
  },
  methods: {
    deleteSuspendedMembers: function() {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '确定删除所有不在组织的成员吗？',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger',
        message: CONFIRM_CONTENT
      }).$on('ensureClicked', function() {
        return Skylark.Libs.Ajax.delete("/admin/settings/namespace_status/suspended_members", {
          success: function() {
            return Skylark.Bridge.newAlertify('所有不在组织成员删除成功', {
              type: 'success'
            });
          },
          error: function(xhr, status, error) {
            return Skylark.Bridge.newAlertify('删除失败', {
              type: 'error'
            });
          }
        });
      });
    },
    exportConfirmPopoverCancel: function() {
      return this.$refs.exportConfirmPopoverRef.close();
    },
    exportUsers: function() {
      return Skylark.Libs.Ajax.get("/admin/settings/namespace_status/export_binding", {
        contentType: 'application/json; charset=utf-8',
        success: () => {
          Skylark.Bridge.newAlertify('已成功添加导出任务', {
            type: 'success'
          });
          return this.exportConfirmPopoverCancel();
        },
        error: function() {
          return Skylark.Bridge.newAlertify('添加导出任务失败', {
            type: 'error'
          });
        }
      });
    }
  }
});
